module.exports = __webpack_public_path__ + "static/media/pulverizado.45adb372.png";